<template>
  <div class="personal-view">
    <div class="menu">
      <menu-list></menu-list>
    </div>
    <div class="content">
      <!-- <div class="left-nav">
        <sidebar-two :title="sidebarTwoTitle" :list="sidebarTwoList" @selectMenu="selectMenu"></sidebar-two>
      </div> -->
      <div class="right-middle">
        <nav-menu
         :navMenuList="navMenuList"
         @handleSelect="handleSelect"
         :activeIndex="activeIndex"></nav-menu>
        <!-- <div class="search-criteria">
          <ul>
            <li v-for="(item,index) in searchCriteria" :key="index">
              <div class="left-title">{{item.text}}</div>
              <ul class="right-val">
                <li v-for="(cItem,i) in item.list" :key="i">
                  <span @click="switchSpan(index, i)" :class="cItem.isActive ? 'spanActive' : ''">{{cItem.val}}</span>
                </li>
              </ul>
            </li>
          </ul>
        </div> -->
        <div class="data-view">
          <ul>
            <li v-for="(item,index) in dataList" :key="index">
              <div class="bd" :class="index < 3 ? 'bangdan' : ''">
                {{index + 1}}
                <span v-show="index > 2">.</span>
              </div>
              <div class="img-d" @click="goDetails(item.id)">
                <img :src="item.imgUrl" alt="">
              </div>
              <div class="content-d">
                <p class="p-name" v-html="item.name"></p>
                <p class="p-money">
                  ￥{{item.promotionPrice ? item.promotionPrice : item.money}}
                  <span v-show="item.promotionPrice ? true : false">
                    定价：￥{{item.money}}
                  </span>
                </p>
                <p class="p-eBookPrice">
                  <span v-show="item.eBookPrice">
                    电子书:￥
                    <!-- {{item.eBookPrice}} -->
                    {{item.paperPromotionPrice ? item.paperPromotionPrice : item.eBookPrice}}
                    <span style="text-decoration: line-through" v-show="item.paperPromotionPrice">
                      定价：{{item.eBookPrice}}
                    </span>
                  </span>
                  </p>
                <p class="p-eBookPrice">
                  {{item.author}}
                </p>
                <el-rate
                  class="star"
                  v-model="item.star"
                  disabled
                  show-score
                  text-color="red"
                  score-template="{value}颗星">
                </el-rate>
                <div class="d-describe" v-html="item.describe"></div>
                <p class="p-btns">
                  <button @click="trialReading(item)">在线试读</button>
                  <img
                    @click="shoppingCart(item)"
                    :src="item.isGwc ? gwc2 : gwc1"
                    alt=""
                    :class="item.isGwc ? 'imgActive' : ''">
                  <img @click="collection(item)" :src="item.isSc ? star2 : star1" alt="">
                </p>
              </div>
            </li>
          </ul>
          <div class="pagination">
            <el-pagination
              background
              @current-change="handleCurrentChange"
              :current-page.sync="currentPage"
              :page-size="pageSize"
              layout="prev, pager, next, jumper"
              :total="total">
            </el-pagination>
          </div>
        </div>
        <!-- <router-view></router-view> -->
      </div>
    </div>
  </div>
</template>
<script>
import Menu from '@/base/menu/menu'
import SidebarTwo from '@/base/sidebar2/sidebar2'
import NavMenu from '@/base/navmenu/navmenu'
export default {
  name: '',
  components: {
    'menu-list': Menu,
    'sidebar-two': SidebarTwo,
    'nav-menu': NavMenu
  },
  data () {
    return {
      activeIndex: '0',
      navMenuList: [{
        text: '新书点击榜',
        pathName: ''
      }, {
        text: 'TOP畅销榜',
        pathName: ''
      }, {
        text: '好评推荐榜',
        pathName: ''
      }
      // , {
      //   text: '价格排行榜',
      //   pathName: ''
      // }
      ],
      currentPage: 1,
      total: 0,
      pageSize: 10,
      sidebarTwoTitle: '个人中心',
      jiantou1: require('@/assets/images/fl/jt1.png'),
      jiantou2: require('@/assets/images/fl/jt2.png'),
      jiage1: require('@/assets/images/fl/jg1.png'),
      jiage2: require('@/assets/images/fl/jg2.png'),
      gwc1: require('@/assets/images/fl/gwc1.png'),
      gwc2: require('@/assets/images/fl/gwc2.png'),
      star1: require('@/assets/images/fl/star1.png'),
      star2: require('@/assets/images/fl/star2.png'),
      sidebarTwoList: [],
      searchCriteria: [{
        text: '周榜',
        list: [{
          val: '全部',
          isActive: true
        }, {
          val: '近一周',
          isActive: false
        }, {
          val: '2周',
          isActive: false
        }, {
          val: '3周',
          isActive: false
        }]
      }, {
        text: '月榜',
        list: [{
          val: '全部',
          isActive: true
        }, {
          val: '1月',
          isActive: false
        }, {
          val: '2月',
          isActive: false
        }, {
          val: '3月',
          isActive: false
        }, {
          val: '4月',
          isActive: false
        }]
      }, {
        text: '年榜',
        list: [{
          val: '全部',
          isActive: true
        }, {
          val: '2018年',
          isActive: false
        }, {
          val: '2017年',
          isActive: false
        }, {
          val: '2016年',
          isActive: false
        }, {
          val: '2015年',
          isActive: false
        }, {
          val: '2014年',
          isActive: false
        }]
      }],
      dataList: [
      //   {
      //   id: '1',
      //   imgUrl: require('@/assets/images/2.png'),
      //   name: '把话说到心窝里',
      //   money: '29.90',
      //   eBookPrice: '',
      //   author: '王阳明',
      //   star: 5,
      //   describe: '你看大家撒的撒而爱的撒旦撒大菩萨模块你看大家撒的撒而爱的撒旦撒大菩萨模块',
      //   promotionPrice: null,
      //   isGwc: true,
      //   isSc: true
      // }, {
      //   id: '4',
      //   imgUrl: require('@/assets/images/2.png'),
      //   name: '把话说到心窝里',
      //   money: '29.90',
      //   eBookPrice: '6.00',
      //   author: '王阳明',
      //   star: 1.9,
      //   describe: '你看大家撒的撒而爱的撒旦撒大菩萨模块',
      //   promotionPrice: '',
      //   isGwc: false,
      //   isSc: false
      // }, {
      //   id: '2',
      //   imgUrl: require('@/assets/images/2.png'),
      //   name: '把话说到心窝里',
      //   money: '29.90',
      //   eBookPrice: '',
      //   author: '王阳明',
      //   star: 1,
      //   describe: '你看大家撒的撒而爱的撒旦撒大菩萨模块',
      //   promotionPrice: '10.22',
      //   isGwc: true,
      //   isSc: false
      // }, {
      //   id: '3',
      //   imgUrl: require('@/assets/images/2.png'),
      //   name: '把话说到心窝里',
      //   money: '29.90',
      //   eBookPrice: '6.00',
      //   author: '王阳明',
      //   promotionPrice: '5.02',
      //   star: 3,
      //   describe: '你看大家撒的撒而爱的撒旦撒大菩萨模块',
      //   isGwc: false,
      //   isSc: true
      // }
      ]
    }
  },
  methods: {
    // selectMenu (index) {
    //   // console.log(this.sidebarTwoList[index].text + 2)
    //   this.activeIndex = '0'
    //   // this.$router.push({
    //   //   name: this.sidebarTwoList[index].pathName
    //   // })
    // },
    // switchSpan (index, cindex) {
    //   let list = this.searchCriteria[index].list
    //   list.forEach((e, i) => {
    //     e.isActive = i === cindex
    //   })
    // },
    // clickFilter (index) { // 切换排序
    //   this.filterList.forEach((e, i) => {
    //     e.isTrue = i === index
    //   })
    // },
    trialReading (item) { // 在线试读
      if (item.eBookPrice) {
        let routeData = this.$router.resolve({
          name: 'Book',
          query: {
            bookId: item.id,
            type: 1
          }
        })
        window.open(routeData.href, '_blank')
        // window.open('http://localhost:8080/#/book?bookId=' + `${item.id}&type=1`)
      } else {
        alert('该书籍没有电子书')
      }
    },
    shoppingCart (item) { // 购物车
      const state = item.isGwc
      const userId = this.$store.state.userMsg.id
      if (!userId) {
        this.$router.push({
          name: 'Login'
        })
      } else {
        if (!state) {
          const bookId = item.id
          const par = `?bookId=${bookId}&userId=${userId}&type=0`
          const bookPrice = item.eBookPrice
          this.$get(this.$allUrl.addCart + par).then(res => {
            if (res.code === '0') {
              this.$message({
                message: '添加成功',
                type: 'success'
              })
              item.isGwc = true
              this.$root.eventHub.$emit('update_shoppingNum')
            } else {
              this.$message.error('添加失败')
            }
          })
          if (bookPrice) {
            const par2 = `?bookId=${bookId}&userId=${userId}&type=1`
            this.$get(this.$allUrl.addCart + par2).then(res => {
              if (res.code !== '0') {
                this.$message.error('电子书加入购物车失败')
              } else {
                this.$root.eventHub.$emit('update_shoppingNum')
              }
            })
          }
        }
      }
    },
    collection (item) { // 收藏
      const userId = this.$store.state.userMsg.id
      if (!userId) {
        this.$router.push({
          name: 'Login'
        })
      } else {
        if (!item.isSc) {
          const bookId = item.id
          const par = `?bookId=${bookId}&userId=${userId}`
          this.$get(this.$allUrl.addFavorite + par).then(res => {
            if (res.code === '0') {
              this.$notify({
                title: '成功',
                message: '已成功收藏',
                type: 'success',
                showClose: false,
                duration: 1500
              })
              item.isSc = true
            } else {
              this.$message.error(res.message)
            }
          })
        }
      }
    },
    handleCurrentChange (val) { // 分页
      const activeIndex = this.activeIndex
      const start = (val - 1) * this.pageSize
      if (activeIndex === '3') {
        this.getRanking('4', start)
      } else {
        this.switchType(activeIndex, start)
      }
    },
    handleSelect (key) { // 切换榜单
      this.activeIndex = key
      this.currentPage = 1
      console.log(key)
      if (key === '3') {
        this.getRanking('4', '0')
      } else {
        this.switchType(key, '0')
      }
    },
    getRanking (type, start) { // 获取排行榜数据
      const userId = this.$store.state.userMsg.id
      const pageSize = this.pageSize
      const par = userId ? `?type=${type}&start=${start}&num=${pageSize}&period=year&userId=${userId}` : `?type=${type}&start=${start}&num=${pageSize}&period=year`
      this.$get(this.$allUrl.getRanking + par).then(res => {
        if (res.code === '0') {
          const list = res.data
          this.total = res.recordsTotal // 总条数
          this.dataList = []
          const imgAdmin = this.$allUrl.imgAdmin
          list.forEach(e => {
            this.dataList.push({
              id: e.bookId,
              imgUrl: imgAdmin + e.coverUrl,
              name: e.bookName,
              money: e.paperPrice, // 价格
              promotionPrice: e.promotionPrice,
              eBookPrice: e.emark === 0 ? '' : e.bookPrice, // 电子书价格
              author: e.bookAuthors,
              star: e.starLevel,
              describe: e.bookSummary,
              isSc: e.favorite !== null,
              isGwc: false,
              paperPromotionPrice: e.paperPromotionPrice
            })
          })
        }
      })
    },
    switchType (type, start) {
      switch (type) {
        case '0':
          this.getRanking('3', start)
          break
        case '1':
          this.getRanking('1', start)
          break
        case '2':
          this.getRanking('2', start)
          break
        default:
          break
      }
    },
    testingUser (e) {
      const userId = this.$store.state.userMsg.id
      if (!userId) {
        this.$router.push({
          name: 'Login'
        })
      }
    },
    goDetails (id) {
      this.$router.push({
        name: 'GoodsDetails',
        query: {
          id: id
        }
      })
    }
  },
  mounted () {
    const type = this.$route.params.type
    if (type) {
      this.activeIndex = type
      this.switchType(type, '0')
    } else {
      this.getRanking('3', '0')
    }
  }
}
</script>
<style lang="less" scoped>
  .personal-view{
    .menu{
      margin: 20px auto;
      width: 600px;
    }
    .content{
      display: flex;
      .left-nav{
        width: 200px;
      }
      .right-middle{
        flex: 1;
        margin-left: 20px;
        .search-criteria{
          background: #EDEDEE;
          ul{
            list-style: none;
            padding: 0 10px;
            margin: 0;
            margin-top: 20px;
            font-size: 14px;
            border: 1px solid #dddddd;
            li:last-child{
              border: 0;
            }
            li{
              display: flex;
              line-height: 30px;
              border-bottom: 1px dashed #d2c7c7;
              .left-title{
                width: 60px;
                color: #666666;
              }
              .right-val{
                display: flex;
                border: 0;
                margin: 0;
                li{
                  width: 70px;
                  color: #999999;
                  border: 0;
                  span{
                    cursor: pointer;
                  }
                  .spanActive{
                    color: #990000;
                  }
                }
              }
            }
          }
        }
        .data-view{
          margin-top: 20px;
          ul{
            list-style: none;
            padding: 0;
            margin: 0;
            display: flex;
            flex-wrap: wrap;
            li{
              width: 50%;
              display: flex;
              padding: 0 0 20px 0;
              border-bottom: 1px solid #DDDDDD;
              .bd{
                min-width: 30px;
                height: 34px;
                line-height: 34px;
                color: #990000;
                text-align: center;
              }
              .bangdan{
                background-image: url('../../assets/images/fl/bd.png');
                color: white;
              }
              .img-d{
                font-size: 0;
                padding-left: 12px;
                padding-top: 30px;
                img{
                  width: 137px;
                  height: 196px;
                }
              }
              .content-d{
                padding-left: 15px;
                padding-top: 30px;
                flex: 1;
                padding-right: 60px;
                font-size: 14px;
                overflow: hidden;
                p{
                  padding: 10px 0 0 0;
                  margin: 0;
                }
                .p-name{
                  color: #35353b;
                  font-size: 16px;
                  padding-top: 0;
                  overflow: hidden;
                  text-overflow:ellipsis;
                  white-space: nowrap;
                }
                .p-money{
                  color: #de0024;
                  font-weight: 600;
                  font-size: 16px;
                  span{
                    font-weight: 200;
                    text-decoration: line-through;
                    color: #A2A2A2;
                    font-size: 14px;
                  }
                }
                .p-eBookPrice{
                  color: #A2A2A2;
                  height: 19px;
                }
                .star{
                  margin-top: 10px;
                }
                .d-describe{
                  margin-top: 10px;
                  height: 37px;
                  overflow: hidden;
                  word-break: break-all;
                  display: -moz-box;
                  -moz-box-orient:vertical;
                  display: -webkit-box;
                  -webkit-box-orient:vertical;
                  text-overflow: ellipsis;
                  -webkit-line-clamp: 2;
                }
                .p-btns{
                  vertical-align: middle;
                  button{
                    width: 100px;
                    height: 28px;
                    background-color: #B7151E;
                    color: white;
                    outline: none;
                    border: 0;
                    border-radius: 6px;
                    cursor: pointer;
                    float: left;
                  }
                  img{
                    padding: 0 10px;
                    cursor: pointer;
                  }
                  .imgActive{
                    cursor: auto;
                  }
                }
              }
            }
          }
          .pagination{
            text-align: right;
            padding: 50px 0;
          }
        }
      }
    }
  }
</style>
<style>
.el-pagination.is-background .el-pager li:not(.disabled).active{
    background: #B7151E !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/Ranking/ranking.vue


// WEBPACK FOOTER //
// src/components/Ranking/ranking.vue